import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appAddress } from "../App";

function UserAPI(token) {
  const [isLogged, setIsLogged] = useState(false)
  const [isAdmin, setIsAdmin] = useState(false)
  const [cart, setCart] = useState([])
  const [history, setHistory] = useState([])

    useEffect(() => {
        if (token) {
            const getUser = async () => {
                try {
                    const res = await axios.get(`https://api.niadoffice.com/user/userInfor`, {
                    // const res = await axios.get(`${appAddress}/user/userInfor`, {
                        headers: {Authorization: token}
                    })
                    
                    setIsLogged(true) 
                        res.data.role === 1 ? setIsAdmin(true) : setIsAdmin(false) 

                    setCart(res.data.cart)
                } catch (err) {
                    toast.error(err.response.data.msg, {
                        position:"bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            };
            
            getUser();
        }
    }, [token]);
    

    // const addCart = async (product) => {

    //     if (!isLogged) return toast.error("please, first login to your account", {
    //         position:"bottom-right",
    //         autoClose: 5000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         });

    //     const check = cart.every(item => {
    //         return item._id !== product._id
    //     });

        
    //     await axios.patch('/user/addcart', {cart: [...cart, {...product, quantity: 1}]}, {
    //         headers: { Authorization: token }
    //     });

    //     if (check) {
    //         setCart([...cart, {...product, quantity: 1, inStock: product.inStock-=1 }])
            
    //         toast.success("product add to the cart", {
    //             position:"bottom-right",
    //             autoClose: 5000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
                
    //             });
    //     } else {
    //         toast.error("product is available on the cart.", {
    //             position:"bottom-right",
    //             autoClose: 5000,
    //             hideProgressBar: false,
    //             closeOnClick: true,
    //             pauseOnHover: true,
    //             draggable: true,
    //             progress: undefined,
                
    //             });
    //     }
    // };

    return {
        isLogged: [isLogged, setIsLogged],
        isAdmin: [isAdmin, setIsAdmin],
        // cart: [cart, setCart],
        // addCart: addCart,
        history: [history, setHistory],
        toast: toast
    };
}

export default UserAPI;